import React from "react";
import { Form } from "@redriver/cinnamon";

const AdditionalDocumentUploadForm = ({ onChangeUpload, ...props }) => {
  return (
    <Form {...props}>
      <Form.Input field="reference" label="Reference" required />
      <Form.FileUpload
        field="templateUpload"
        label="Upload Template"
        fileExtensionTypes={["docx"]}
        customValidator={(_, __, ___, { value }) => {
          !!value?.templateUpload && onChangeUpload(value?.templateUpload);
        }}
        required
      />
    </Form>
  );
};

export default AdditionalDocumentUploadForm;
